import { createStore } from "vuex";
import { webSocketUrl } from "../common/project.config";
import axios from "../util/axios";
import { ElMessage } from "element-plus";
import i18n from "../i18n/index";
import User from "./User";
import Store from "./Store";
import Member from "./Member";
import Pay from "./Pay";
import Upgrade from "./Upgrade";
import Photo from "./Photo";
import Wall from "./Wall";
import Chat from "./Chat";
import Message from "./Message";
import Report from "./Report";
import Notification from "./Notification";
import GlobalGift from "./GlobalGift";

export default createStore({
  state: {
    lang: localStorage.getItem("lang") || "en",
    general_authority: [],
    silvercard_authority: [],
    goldcard_authority: [],
    ws: null,
    wsReconnectTimer: null,
  },
  mutations: {
    // 修改语言
    changeLang(state, lang) {
      state.lang = lang;
    },
    // 设置用户权限
    setAuthority(state, data) {
      state.general_authority = data.vip0;
      state.silvercard_authority = data.vip1;
      state.goldcard_authority = data.vip2;
    },

    closeWebsocket(state) {
      clearTimeout(state.wsReconnectTimer);
      state.wsReconnectTimer = null;
      const ws = state.ws;
      state.ws = null;
      if (ws) {
        ws.onopen = ws.onmessage = ws.onclose = null;
        ws.close();
      }
    },
    clearChatSession(state) {
      state.Chat.chatList = [];
      state.Chat.globalChatList = [];
      state.Chat.curUser = {};
      state.Chat.service = {};
      state.Chat.count = 0;
    },
  },
  actions: {
    async logout({ commit }) {
      try {
        const res = await axios.post_form("/member/index/logout", {});
        if (res.data.status != 200) throw new Error("Logout rejected");
      } catch (error) {
        ElMessage.error(i18n.global.t("tips.sendfail"));
        return false;
      }
      commit("logout");
      commit("closeWebsocket");
      commit("clearChatSession");
      return true;
    },
    // 更新用户信息
    updateUserInfo({ commit, state }) {
      axios.post_form("/member/index/userinfo", {}).then((res) => {
        res = res.data;
        if (res.status == 200) {
          commit("updateUserInfo", res.data);
          let vip = state.User.vip;
          if (vip == 0) {
            commit("setUserAuthority", state.general_authority);
          } else if (vip == 1) {
            commit("setUserAuthority", state.silvercard_authority);
          } else if (vip == 2) {
            commit("setUserAuthority", state.goldcard_authority);
          }
        }
      });
    },
    // 设置用户权限
    updateUserAuthority({ commit, state }) {
      let vip = state.User.vip;
      if (vip == 0) {
        commit("setUserAuthority", state.general_authority);
      } else if (vip == 1) {
        commit("setUserAuthority", state.silvercard_authority);
      } else if (vip == 2) {
        commit("setUserAuthority", state.goldcard_authority);
      }
    },
    // 初始化websocket
    initWebsocket({ dispatch, commit, state }) {
      const token = localStorage.getItem("token") || "";
      if (!state.User.isLogin || state.User.status != 1 ||
          !/^[a-f0-9]{32}$/.test(token) || state.ws) return;
      clearTimeout(state.wsReconnectTimer);
      state.wsReconnectTimer = null;
      const ws = new WebSocket(webSocketUrl);
      state.ws = ws;
      ws.onopen = () => {
        if (state.ws !== ws) return;
        ws.send(
          JSON.stringify({
            opt: "100",
            hasInit: "no",
            token,
            origin: true,
          })
        );
      };
      ws.onmessage = (res) => {
        if (state.ws !== ws) return;
        let data = JSON.parse(res.data);
        if (data.opt == 10) {
          commit("logout");
          commit("closeWebsocket");
          commit("clearChatSession");
          return;
        }
        if (data.status == "success") {
          dispatch("chatEvent", data);
        }
      };
      ws.onclose = () => {
        if (state.ws !== ws) return;
        state.ws = null;
        if (state.User.isLogin && localStorage.getItem("token") === token) {
          state.wsReconnectTimer = setTimeout(() => dispatch("initWebsocket"), 3000);
        }
      };
    },
    // 发送websocket消息
    wssend({ state }, data) {
      if (state.ws && state.ws.readyState === WebSocket.OPEN) {
        state.ws.send(JSON.stringify(data));
      }
    },
  },
  modules: {
    User,
    Store,
    Member,
    Pay,
    Upgrade,
    Photo,
    Wall,
    Chat,
    Message,
    Report,
    Notification,
    GlobalGift,
  },
});
